






import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { statisticsModule } from '@/store/modules/frames/statistics.module';
import GLoading from '@/components/GLoading.vue';
import { eventGiftCourseModule } from '@/store/modules/frames/event-gift-course.module';

@Component({
  name: 'GSurveyAnalyzeCompetencyChart',
  components: { GLoading },
})
export default class GSurveyAnalyzeCompetencyChart extends mixins(GPageBase) {
  mounted() {}

  get options(): any {
    return eventGiftCourseModule.echartService.options;
  }

  get loading(): boolean {
    return eventGiftCourseModule.loading;
  }
}
